import React from 'react';
import { VerifiedVetIcon } from '@/icons/VerifiedVet';
import { ArticleSectionTitle } from '../ArticleSectionTitle';
import { ArticleAuthorBlockDetails } from './ArticleAuthorBlockDetails/ArticleAuthorBlockDetails';
import { AuthorBlockRelatedArticles } from '../../wag-react/components/author-block/AuthorBlock';
import { Box } from '../../wag-react/next-components/box';
export type ArticleAuthorBlockProps = {
  writtenBy: {
    name: string;
    image?: string;
    bio?: string;
  };
  reviewedBy?: {
    name: string;
    image?: string;
    bio?: string;
  };
  relatedArticles?: AuthorBlockRelatedArticles[];
};
export const ArticleAuthorBlock = ({
  writtenBy,
  reviewedBy,
  relatedArticles
}: ArticleAuthorBlockProps) => <Box data-sentry-element="Box" data-sentry-component="ArticleAuthorBlock" data-sentry-source-file="ArticleAuthorBlock.tsx">
    <ArticleSectionTitle mt={0} data-sentry-element="ArticleSectionTitle" data-sentry-source-file="ArticleAuthorBlock.tsx">About the authors</ArticleSectionTitle>
    <Box display="grid" gridTemplateColumns={['1fr', '1fr 1fr']} gridGap={['24px', '12px']} data-sentry-element="Box" data-sentry-source-file="ArticleAuthorBlock.tsx">
      <ArticleAuthorBlockDetails {...writtenBy} preName="Written By" relatedArticles={relatedArticles} data-sentry-element="ArticleAuthorBlockDetails" data-sentry-source-file="ArticleAuthorBlock.tsx" />
      {reviewedBy ? <ArticleAuthorBlockDetails preName="Reviewed By" postName={<VerifiedVetIcon width="16px" height="16px" ml="6px" mb="2px" position="relative" top="3px" />} {...reviewedBy} /> : null}
    </Box>
  </Box>;